export default "__VITE_ASSET__t$uC_$63__"